import type { ElasticSearchResponse } from '../@types/ElasticSearchResponse';
import type { VehicleFacet } from '../@types/VehicleFacet';
import type { Actions } from '../actions';
import {
  RCV_LIST_VEHICLE_FACETS,
  REQ_LIST_VEHICLE_FACETS,
  REQUEST_FAILED,
} from '../actions/facets';
import { requestStatus, responseStatus } from '../shared/statuses';

interface FacetsState {
  requestStatus: number;
  responseStatus: number;
  facets: ElasticSearchResponse<VehicleFacet> | null;
}

const _initialState: FacetsState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  facets: null,
};

const facetsReducer = (state: FacetsState = _initialState, action: Actions): FacetsState => {
  switch (action.type) {
    case REQ_LIST_VEHICLE_FACETS:
      return {
        ...state,
        facets: null,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_LIST_VEHICLE_FACETS:
      return {
        ...state,
        facets: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default facetsReducer;
